import { render } from "./FruitIndexIframe.vue?vue&type=template&id=595c99b4"
import script from "./FruitIndexIframe.vue?vue&type=script&lang=js"
export * from "./FruitIndexIframe.vue?vue&type=script&lang=js"
script.render = render

export default script